import { combineReducers } from 'redux';
import processStateReducer from './processStateReducer';
import activityStateReducer from './activityStateReducer';
import activityRunConsoleMessageStateReducer from './activityRunConsoleMessageStateReducer';
import activityRunEventStateReducer from './activityRunEventStateReducer';
import artifactStateReducer from './artifactStateReducer';
import activityRunStateReducer from './activityRunStateReducer';
import containerImageStateReducer from './containerImageStateReducer';
import processScheduleStateReducer from './processScheduleStateReducer';
import processStatusStateReducer from './processStatusStateReducer';
import userStateReducer from './userStateReducer';
import personalApiKeyStateReducer from './personalApiKeyStateReducer';
import secretStateReducer from './secretStateReducer';
import workerDownloadStateReducer from './workerDownloadStateReducer';
import assistantDownloadStateReducer from './assistantDownloadStateReducer';
import activityTemplateStateReducer from './activityTemplateStateReducer';
import packageStateReducer from './packageStateReducer';
import slackStateReducer from './slackStateReducer';
import feedbackStateReducer from './feedbackStateReducer';
import billingStateReducer from './billingStateReducer';
import invoiceStateReducer from './invoiceStateReducer';
import planStateReducer from './planStateReducer';
import assistantStateReducer from './assistantStateReducer';
import assistantRunStateReducer from './assistantRunStateReducer';
import serviceDeskStateReducer from './serviceDeskStateReducer';
import workspaceKeysStateReducer from './workspaceKeysStateReducer';

export default combineReducers({
  activities: activityStateReducer,
  artifacts: artifactStateReducer,
  activityRunConsoleMessages: activityRunConsoleMessageStateReducer,
  activityRunEvents: activityRunEventStateReducer,
  activityRuns: activityRunStateReducer,
  activityTemplates: activityTemplateStateReducer,
  assistants: assistantStateReducer,
  assistantRuns: assistantRunStateReducer,
  packages: packageStateReducer,
  containerImages: containerImageStateReducer,
  processes: processStateReducer,
  processSchedules: processScheduleStateReducer,
  processStatuses: processStatusStateReducer,
  users: userStateReducer,
  workerDownloads: workerDownloadStateReducer,
  assistantDownloads: assistantDownloadStateReducer,
  personalApiKeys: personalApiKeyStateReducer,
  secrets: secretStateReducer,
  slack: slackStateReducer,
  feedback: feedbackStateReducer,
  serviceDesk: serviceDeskStateReducer,
  billing: billingStateReducer,
  invoices: invoiceStateReducer,
  plans: planStateReducer,
  workspaceKeys: workspaceKeysStateReducer,
});
